<template>
  <transition name="fade">
    <div class="userModal" v-if="show">
      <div class="overlay"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="loading" v-if="loading"></div>
        <div class="close" v-on:click="close(false)"></div>
        <h2>Cell Attachment</h2>
        <div class="formContentSc" v-if="att">
          <div class="attActions">
            <div class="attAction edit" v-on:click="close(true, 'edit')"></div>
            <div class="attAction delete" v-on:click="deleteAtt"></div>
          </div>
          <div class="attIcon" :class="att.type"></div>
          <div class="attItem" v-if="att.type === 'link'">
            <h5>External Link</h5>
            <h4><a :href="att.value" target="_blank">{{att.value}}</a></h4>
          </div>
          <div class="attItem dialog" v-else-if="att.type === 'media'">
            <h5>Media File</h5>
            <h4>{{att.value.name || 'Unknown'}}</h4>
          </div>
          <div class="attItem" v-else>
            <h5>Dialog</h5>
            <h4 v-for="(item, i) in att.value" :key="i">
              <span v-if="item.title">{{item.title}}</span>
              <span class="untitled" v-else>Untitled dialog content</span>
            </h4>
          </div>
        </div>
      </div>
      <Confirmation ref="confirmDialog"/>
    </div>
  </transition>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';

export default {
  components: { Confirmation },
  data() {
    return {
      loading: false,
      show: false,
      description: '',
      saving: false,
      id: null,
      att: null,
    };
  },
  methods: {
    open(d, n) {
      this.att = d;
      this.next = n;
      this.show = true;
      this.saving = false;
    },
    close(b, c) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, c);
    },
    deleteAtt() {
      this.$refs.confirmDialog.open({
        title: 'Delete Attachment',
        desc: 'Are you sure you want to delete this attachment?',
      }, (b) => {
        if (b) this.close(true, 'delete');
      });
    },
  },
};
</script>

<style scoped lang="scss">
.userModal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 991;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 40px 0;

  .fieldCnt.hasError{
    .field{
      border-color: red;
    }
    .fieldError{
      display: block;
    }
  }
  .fieldCnt.hasPrefix{
    position: relative;
    .field{
      padding-left: 40px;
    }
    .fieldPrefix{
      position: absolute;
      left: 10px; top: 35px;
      z-index: 3;
      color: #767676;
    }
  }

  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
  }
  .modalContent{
    position: relative;
    z-index: 2;
    background: #fff;
    margin: auto;
    border-radius: 5px;
    overflow: hidden;
    transition: all .3s ease;
    width: 620px;
    box-sizing: border-box;
    padding: 40px 60px;
    .loading{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #fff;
      background-color: rgba(255,255,255,.7);
      backdrop-filter: saturate(180%) blur(20px);
      background-image: url(../assets/loading-2.svg);
      background-position: center;
      background-size: 70px auto;
      background-repeat: no-repeat;
      z-index: 9;
    }
    .close{
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      right: 10px;
      top: 10px;
      opacity: .4;
      cursor: pointer;
      transition: all .2s linear;
      &:hover{
        background-color: #e5e5e5;
        opacity: .7;
      }
    }
    h2{
      font-size: 24px;
      font-weight: 600;
      margin: 0 0 10px;
    }
    .formContentSc{
      border-top: #eee 1px solid;
      max-height: 64vh;
      box-sizing: border-box;
      overflow: auto;
      margin: 0 -60px;
      padding: 20px 0 0;
      box-sizing: border-box;
      position: relative;
      .attActions{
        position: absolute;
        right: 60px; top: 20px;
        display: flex;
        z-index: 3;
        .attAction{
          width: 34px; height: 34px;
          border-radius: 50%;
          margin-left: 5px;
          background-size: 16px auto;
          background-position: center;
          background-repeat: no-repeat;
          transition: all .3s ease;
          cursor: pointer;
          &.edit{
            background-image: url(../assets/edit-blue.png);
          }
          &.delete{
            background-image: url(../assets/delete.png);
          }
          &:hover{
            box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
          }
        }
      }
      .attIcon{
        position: absolute;
        left: 60px; top: 10px;
        background-color: #f5f5fe;
        border-radius: 3px;
        width: 40px; height: 40px;
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        z-index: 3;
        &.dialog{
          background-image: url(../assets/007-dialog.png);
        }
        &.media{
          background-image: url(../assets/file-download.png);
        }
        &.link{
          background-image: url(../assets/url.png);
        }
      }
      .attItem{
        padding: 0 120px;
        position: relative;
        h5{
          text-transform: uppercase;
          color: #767676;
          font-size: 14px;
          font-weight: 600;
          margin: 0 0 10px;
        }
        h4{
          margin: 0 0 10px;
          font-size: 16px;
          font-weight: 600;
          .untitled{
            color: #767676;
            font-style: italic;
          }
        }
      }
    }
  }
}
</style>
